/* ============================================================
   MDN Theme JS — Moby Dick Nauticals
   Cart drawer, nav, search, ATC, toast
   ============================================================ */

(function () {
  'use strict';

  /* ── Selectors ─────────────────────── */
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  /* ── Toast ───────────────────────── */
  let toastTimer;
  window.mdnShowToast = function (msg) {
    let toast = $('#mdn-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'mdn-toast';
      toast.className = 'mdn-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 3000);
  };

  /* ── Cart helpers ───────────────────── */
  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const countEl = $('#mdn-cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.dataset.count = cart.item_count;
        }
        const body = $('#mdn-cart-body');
        if (!body) return;
        if (cart.item_count === 0) {
          body.innerHTML = '<p class="mdn-cart-drawer__empty">Your cart is empty.</p>';
          const oldSub = $('.mdn-cart-drawer__subtotal');
          if (oldSub) oldSub.remove();
        } else {
          const items = cart.items.map((item, idx) => {
            let imgSrc = '';
            if (item.featured_image && item.featured_image.url) {
              imgSrc = item.featured_image.url;
            } else if (item.image) {
              imgSrc = item.image;
            }
            if (imgSrc) {
              imgSrc = imgSrc.replace(/(\.jpg|\.jpeg|\.png|\.webp|\.gif)(?=\?|$)/i, '_120x120$1');
            }
            const showVariant = item.variant_title &&
              item.variant_title !== 'null' &&
              item.variant_title !== 'Default Title' &&
              item.variant_title.trim() !== '';
            return `
            <div class="mdn-cart-item">
              <div class="mdn-cart-item__img">
                ${imgSrc
                  ? `<img src="${imgSrc}" alt="${item.product_title}" loading="lazy" onerror="this.style.display='none'">`
                  : `<div style="width:64px;height:64px;background:var(--sand);border-radius:4px;"></div>`
                }
              </div>
              <div style="flex:1;min-width:0;">
                <p class="mdn-cart-item__name">${item.product_title}</p>
                ${showVariant ? `<p style="font-size:0.78rem;color:var(--muted);margin-bottom:0.2rem;">${item.variant_title}</p>` : ''}
                <p class="mdn-cart-item__price">Qty ${item.quantity} &times; ${formatMoney(item.price)}</p>
                <button class="mdn-cart-item__remove" data-line="${idx + 1}">Remove</button>
              </div>
              <div style="font-weight:700;color:var(--navy);white-space:nowrap;flex-shrink:0;">${formatMoney(item.line_price)}</div>
            </div>
          `;
          }).join('');
          body.innerHTML = items;

          const footer = $('.mdn-cart-drawer__footer');
          if (footer) {
            const existingSubtotal = footer.querySelector('.mdn-cart-drawer__subtotal');
            const subtotalHtml = `<div class="mdn-cart-drawer__subtotal"><span>Subtotal</span><span>${formatMoney(cart.total_price)}</span></div>`;
            if (existingSubtotal) existingSubtotal.outerHTML = subtotalHtml;
            else footer.insertAdjacentHTML('afterbegin', subtotalHtml);
          }

          $$('.mdn-cart-item__remove').forEach(btn => {
            btn.addEventListener('click', function () {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ line: parseInt(this.dataset.line), quantity: 0 })
              }).then(() => refreshCartDrawer());
            });
          });
        }
      });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── Cart drawer open/close ─────────────── */
  function openCart() {
    const drawer = $('#mdn-cart-drawer');
    const overlay = $('#mdn-cart-overlay');
    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }

  function closeCart() {
    const drawer = $('#mdn-cart-drawer');
    const overlay = $('#mdn-cart-overlay');
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* Expose for other scripts (product page ATC opens the drawer through
     these so the drawer body is ALWAYS refreshed — fixes "empty drawer
     after add to cart" bug). mdnRefreshCartCount now refreshes the whole
     drawer, not just the badge. */
  window.mdnOpenCart = openCart;
  window.mdnRefreshCartDrawer = refreshCartDrawer;
  window.mdnRefreshCartCount = refreshCartDrawer;

  $('#mdn-cart-toggle')?.addEventListener('click', openCart);
  $('#mdn-cart-close')?.addEventListener('click', closeCart);
  $('#mdn-cart-overlay')?.addEventListener('click', closeCart);

  /* ── BUY NOW repair ────────────────────
     The product template links Buy Now to /checkout?variant=… — a URL
     Shopify ignores (opens checkout with the existing cart only).
     Intercept the click and use the cart permalink /cart/VARIANT:QTY,
     which adds the item and goes straight to checkout. Runs after the
     template's own handler, so the href already holds the currently
     selected variant. */
  const buyNowBtn = document.getElementById('mdn-buy-now');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function (e) {
      const href = this.getAttribute('href') || '';
      const m = href.match(/variant=(\d+)/);
      if (!m) return; /* already a working link — leave it alone */
      e.preventDefault();
      const qtyEl = document.getElementById('mdn-qty');
      const qty = qtyEl ? Math.max(1, parseInt(qtyEl.value) || 1) : 1;
      window.location.href = '/cart/' + m[1] + ':' + qty;
    });
  }

  /* ── Search bar ───────────────────── */
  const searchToggle = $('#mdn-search-toggle');
  const searchBar = $('#mdn-search-bar');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      const open = searchBar.classList.toggle('is-open');
      this.setAttribute('aria-expanded', open);
      searchBar.setAttribute('aria-hidden', !open);
      if (open) searchBar.querySelector('input')?.focus();
    });
  }

  /* ── Mobile nav ───────────────────── */
  const hamburger = $('#mdn-hamburger');
  const mobileNav = $('#mdn-mobile-nav');
  const mobileClose = $('#mdn-mobile-close');

  hamburger?.addEventListener('click', function () {
    mobileNav?.classList.add('is-open');
    mobileNav?.setAttribute('aria-hidden', 'false');
    this.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  });

  mobileClose?.addEventListener('click', closeMobileNav);
  function closeMobileNav() {
    mobileNav?.classList.remove('is-open');
    mobileNav?.setAttribute('aria-hidden', 'true');
    hamburger?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileNav();
      closeCart();
      if (searchBar?.classList.contains('is-open')) {
        searchBar.classList.remove('is-open');
        searchBar.setAttribute('aria-hidden', 'true');
        searchToggle?.setAttribute('aria-expanded', 'false');
      }
    }
  });

  /* ── ATC buttons (collection pages) ──────────── */
  $$('.mdn-atc-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const id = this.dataset.productId;
      const title = this.dataset.productTitle;
      if (!id) return;
      this.textContent = 'Adding...';
      this.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id), quantity: 1 })
      })
      .then(r => {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(item => {
        this.textContent = 'Added!';
        mdnShowToast('Added to cart: ' + (title || item.title));
        setTimeout(() => {
          this.textContent = 'Add to Cart';
          this.disabled = false;
        }, 2000);
        openCart();
      })
      .catch(() => {
        this.textContent = 'Error — Try Again';
        this.disabled = false;
      });
    });
  });

  /* ── Homepage product "Add to Cart" buttons ──────── */
  $$('.mdn-hp__prod-btn').forEach(btn => {
    if (btn.dataset && btn.dataset.id) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(this.dataset.id), quantity: 1 })
        })
        .then(r => {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(item => {
          mdnShowToast('Added: ' + item.title);
          openCart();
        })
        .catch(() => mdnShowToast('Could not add to cart. Please try again.'));
      });
    }
  });

  /* ── Active nav link highlight ─────────────── */
  const path = window.location.pathname;
  $$('.mdn-nav__link').forEach(link => {
    if (link.getAttribute('href') === path) {
      link.classList.add('mdn-nav__link--active');
    }
  });

  /* ── Sticky header shadow on scroll ───────────── */
  const header = $('.mdn-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 20px rgba(10,22,40,0.35)';
      } else {
        header.style.boxShadow = '';
      }
    }, { passive: true });
  }

})();
